import { DataSaverOnOutlined } from "@mui/icons-material";
import ListCreateTab from "components/ListCreateTab";
import Products from "pages/products/Products";
import React from "react";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import { Box } from "@mui/material";
import ProductCreateWizard from "pages/products/ProductCreateWizard";

const ManageProducts = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Product"
        viewIcon={<MedicalServicesIcon />}
        createIcon={<DataSaverOnOutlined />}
        createChildren={<ProductCreateWizard />}
        listChildren={<Products />}
      />
    </Box>
  );
};

export default ManageProducts;
